import { useMutation, useQuery, useQueryClient } from "react-query";
import { apiCall } from "Apis/BaseApi";
import {SettlementEntryDto} from "./Models/SettlementSalesDto";
import {PROJECT_SETTLEMENT_RESULT_CACHE_KEY, PROJECT_SETTLEMENT_SALES_CACHE_KEY} from "./ProjectSettlementApi";

export const SETTLEMENT_ENTRY_CACHE_KEY = 'SETTLEMENT_ENTRY_CACHE_KEY'
export const useSettlementEntry = (id: number) => {
    return useQuery<SettlementEntryDto>([SETTLEMENT_ENTRY_CACHE_KEY, id], async () => {
        return await apiCall<SettlementEntryDto>({
            url: `/settlementEntries/${id}`,
            method: 'GET',
        })
    });
}

export const useMutateSettlementEntry = () => {
    
    const queryClient = useQueryClient();
    
    return useMutation(async (settlementEntry: SettlementEntryDto): Promise<SettlementEntryDto> => {
        if (!settlementEntry.id) {
            return await apiCall<SettlementEntryDto>({
                url: `/settlementEntries`,
                method: 'POST',
                data: settlementEntry
            })
        } else {
            return await apiCall<SettlementEntryDto>({
                url: `/settlementEntries/${settlementEntry.id}`,
                method: 'PUT',
                data: settlementEntry
            })
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(SETTLEMENT_ENTRY_CACHE_KEY)
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_RESULT_CACHE_KEY)
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_SALES_CACHE_KEY)
        }
    })
}

export const useDeleteSettlementEntry = () => {

    const queryClient = useQueryClient();

    return useMutation(async (settlementEntry: SettlementEntryDto): Promise<void> => {
        return await apiCall({
            url: `/settlementEntries/${settlementEntry.id}`,
            method: 'DELETE',
        })
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(SETTLEMENT_ENTRY_CACHE_KEY)
            await queryClient.invalidateQueries(PROJECT_SETTLEMENT_RESULT_CACHE_KEY)
        }
    })
}
